export async function shopCart(payload) {
  const urlencoded = new URLSearchParams();

  urlencoded.append("add_qty", String(payload.add_qty || 1));
  urlencoded.append("csrf_token", payload.csrf_token);
  urlencoded.append(
    "no_variant_attribute_values",
    JSON.stringify(payload.no_variant_attribute_values || [])
  );
  urlencoded.append(
    "product_custom_attribute_values",
    JSON.stringify(payload.product_custom_attribute_values || [])
  );
  urlencoded.append("product_id", String(payload.product_id));
  urlencoded.append("quantity", String(payload.quantity || 1));

  // If variant_values is an array, append each value individually
  if (Array.isArray(payload.variant_values)) {
    payload.variant_values.forEach((val) => {
      urlencoded.append("variant_values", String(val));
    });
  } else if (payload.variant_values) {
    // If it's a single value (like `1`), append it once
    urlencoded.append("variant_values", String(payload.variant_values));
  }

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
  // Add any other custom headers here if needed
  // For example:
  // myHeaders.append("Cookie", "session_id=...");

  const endpoint = "/shop/cart/update";
  const fullUrl = `${window.location.origin}${endpoint}`;

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: urlencoded,
    redirect: "follow",
  };

  const response = await fetch(fullUrl, requestOptions);
  const resultText = await response.text();

  return resultText;
}
